import React from 'react'
import { Truck } from 'lucide-react'
import { CAMPAIGN } from '../config/campaign'

interface ShippingExpectationNoteProps {
  className?: string
}

const ShippingExpectationNote: React.FC<ShippingExpectationNoteProps> = ({ className = '' }) => {
  return (
    <div
      className={`flex items-center gap-3 bg-blue-950/30 border border-blue-800/50 rounded-xl px-4 py-3 ${className}`}
    >
      <Truck className="h-5 w-5 flex-shrink-0 !text-blue-300" aria-hidden="true" />
      <p className="text-sm !text-white/70 font-body leading-snug">
        Shipping is calculated by ZIP at checkout
        <span className="!text-white/40 mx-2" aria-hidden="true">·</span>
        ships frozen via UPS 2-Day by{' '}
        <span className="!text-white/90 font-semibold whitespace-nowrap">{CAMPAIGN.shipDateDisplay}</span>
      </p>
    </div>
  )
}

export default ShippingExpectationNote
